(() => {
	const forgottenForm = document.querySelector('#forgotten-passwd');
	const loginForm = document.querySelector('#login-form');

	loginForm?.querySelector('input[type=email]').focus();

	// |useless|
	$('#login-box input.field').each(function() {
		if ($(this).val()=='') {
			$(this).focus();
			return false;
		}
	});

	document.querySelector('#forgot')?.addEventListener('click', (e) => {
		e.preventDefault();
		const input = forgottenForm.querySelector('input[name=forgotten-mail]');
		forgottenForm.style.display = forgottenForm.style.display === 'block' ? "none" : 'block';
		input.focus();
	})

	loginForm?.addEventListener('submit', (e) => {
		const email = loginForm.querySelector('input[name=mail]');
		const password = loginForm.querySelector('input[name=password]');

		if(email.value === '') {
			e.preventDefault();
			alert("Please enter your email address");
			email.focus();
		} else if(password.value === '') {
			e.preventDefault();
			alert("Please enter your password");
			password.focus();
		}
	})
})();
